import { render, staticRenderFns } from "./leaveForm.vue?vue&type=template&id=8b835176&"
import script from "./leaveForm.vue?vue&type=script&lang=js&"
export * from "./leaveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports